
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","fill":"none"}},[_c('path',{attrs:{"d":"M14.666 11.667v-10M8 15.1l.833-3.433H3.975a1.667 1.667 0 01-1.6-2.134l1.941-6.666a1.667 1.667 0 011.6-1.2h11.25a1.666 1.666 0 011.667 1.666V10a1.667 1.667 0 01-1.667 1.667h-2.3a1.666 1.666 0 00-1.491.925L10.5 18.333A2.61 2.61 0 018 15.1z","stroke":"#fff","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      